import React, { useState, useEffect, useCallback } from "react";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBBtn,
  MDBModalBody,
  MDBSpinner,
} from "mdb-react-ui-kit";
import { getGBussinessInfo } from "../services/apiServices.js";
import tranImg from "./images/Transactions.svg";
import ccImg from "./images/paymentsicons/card-credit.svg";
import cash from "./images/paymentsicons/cash.svg";
import coupon from "./images/paymentsicons/coupon.svg";
import multiple from "./images/paymentsicons/multiple-payments.svg";
import otherpayments from "./images/paymentsicons/other-payment.svg";
import uiImg from "./images/paymentsicons/upi.svg";
import wallet from "./images/paymentsicons/wallet.svg";
// Add these imports
import {
  isDefaultTransIdRequired,
  multipleSplitRequiresTransId,
  validateBusinessTransId,
} from "../utils/paymentTransIdRules";



const PlanChangePayment = ({ 
  open, 
  onClose, 
  amountToPay,
  currentPlanName,
  selectedPlanName,
  onPaymentComplete,
  saving = false,
  serverError = ""
}) => {

  
  console.log("PlanChangePayment Rendered", {
    amountToPay,
    currentPlanName,
    selectedPlanName
  });

// Add these state variables (around line 35)
const [transIdFieldError, setTransIdFieldError] = useState("");
const [dpaymethodsRequireTransId, setDpaymethodsRequireTransId] = useState([]);
  const [dpaymethods, setDpaymethods] = useState([]);
  const [userpaymethods, setUserpaymethods] = useState([]);
  const [apiError, setApiError] = useState(false);
  const [showMultiple, setShowMultiple] = useState(false);
  const [showCoupon, setShowCoupon] = useState(false);
  const [balance, setBalance] = useState(amountToPay); 
  const [curSelMode, setCurSelMode] = useState(null);
  const [transId, setTransId] = useState("");
  const [showError, setShowError] = useState(false);
  const [userpayselect, setUserpayselect] = useState(null);
  const [customModeOption, setCustomModeOption] = useState(null);
  const [inlineError, setInlineError] = useState("");
  
  // Payment info state - follows same structure as POS
  const [payInfo, setPayInfo] = useState({
    cash_amt: "",
    cc_amt: "",
    upi_amt: "",
    upi_input: "",
    wallet_amt: "",
    wallet_input: "",
    userpaymethod: "",
    coupon_input: "",
    coupon_amt: "",
    usr_input: "",
  });

  const totalAmount = Number(amountToPay) || 0;


const updateBalance = useCallback((value, field) => {
  let otherTotal = 0;
  
  if (curSelMode === 6) {
    // Multiple mode: sum all entered amounts
    otherTotal += parseFloat(payInfo.cash_amt) || 0;
    otherTotal += parseFloat(payInfo.cc_amt) || 0;
    otherTotal += parseFloat(payInfo.upi_amt) || 0;
    otherTotal += parseFloat(payInfo.wallet_amt) || 0;
    
    // Calculate remaining balance (can be positive for partial payments)
    const remainingBalance = totalAmount - otherTotal;
    setBalance(remainingBalance < 0 ? 0 : remainingBalance);
  } else if (curSelMode >= 7 && customModeOption) {
    // Custom payment mode
    otherTotal = parseFloat(payInfo.usr_input) || 0;
    const remainingBalance = totalAmount - otherTotal;
    setBalance(remainingBalance < 0 ? 0 : remainingBalance);
  } else if (showCoupon && curSelMode === 5) {
    // Coupon mode
    otherTotal = parseFloat(payInfo.coupon_amt) || 0;
    const remainingBalance = totalAmount - otherTotal;
    setBalance(remainingBalance < 0 ? 0 : remainingBalance);
  } else {
    otherTotal = value;
    const remainingBalance = totalAmount - otherTotal;
    setBalance(remainingBalance < 0 ? 0 : remainingBalance);
  }
  
  console.log("Balance updated:", { totalAmount, otherTotal, remainingBalance: totalAmount - otherTotal });
}, [totalAmount, curSelMode, payInfo, showCoupon, customModeOption]);
  // Update payInfo state
  const updatepayInfo = useCallback((value) => {
    setPayInfo(prev => ({ ...prev, ...value }));
  }, []);

  // Fetch payment methods
  useEffect(() => {
    if (!open) return;
    
    const gymId = localStorage.getItem("loggedUserInfo") 
      ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid 
      : null;
      
    if (!gymId) return;
    
    let cancelled = false;
    (async () => {
      const response = await getGBussinessInfo(gymId);
      if (!response || response === "false") {
        if (!cancelled) setApiError(true);
        return;
      }
      const record = await response.json();
      if (cancelled || !record) return;
      setDpaymethods(record.dpaymethods || []);
      setUserpaymethods(record.userpaymethods || []);

setDpaymethodsRequireTransId(record.dpaymethodsRequireTransId || []); // Add this line


    })();
    return () => {
      cancelled = true;
    };
  }, [open]);

  // Reset state when modal opens
  useEffect(() => {
    if (!open) {
      // Reset all state when modal closes
      setInlineError("");
      setUserpayselect(null);
      setCustomModeOption(null);
      setShowMultiple(false);
      setShowCoupon(false);
      setCurSelMode(null);
      setTransId("");
      setBalance(totalAmount);
      setPayInfo({
        cash_amt: "",
        cc_amt: "",
        upi_amt: "",
        upi_input: "",
        wallet_amt: "",
        wallet_input: "",
        userpaymethod: "",
        coupon_input: "",
        coupon_amt: "",
        usr_input: String(totalAmount || ""),
      });
      setShowError(false);
    } else {
      // Reset balance when modal opens
      setBalance(totalAmount);
    }
  }, [open, totalAmount]);

  // Update balance when payInfo changes in multiple mode
  useEffect(() => {
    if (showMultiple && curSelMode === 6) {
      updateBalance(0);
    }
  }, [payInfo.cash_amt, payInfo.cc_amt, payInfo.upi_amt, payInfo.wallet_amt, showMultiple, curSelMode, updateBalance]);

  // Update balance when coupon amount changes
  useEffect(() => {
    if (showCoupon && curSelMode === 5) {
      updateBalance(0);
    }
  }, [payInfo.coupon_amt, showCoupon, curSelMode, updateBalance]);

  // Update balance when custom amount changes
  useEffect(() => {
    if (curSelMode >= 7 && customModeOption) {
      updateBalance(0);
    }
  }, [payInfo.usr_input, curSelMode, customModeOption, updateBalance]);

// Replace the existing onTransIdChange with:
const onTransIdChange = (e) => {
  const value = e.target.value;
  setTransId(value);
  setShowError(false);
  setTransIdFieldError("");
  setInlineError(""); // Clear any other errors
};


  // Handle payment method selection
// Replace the payAmount function with this version:
const payAmount = (obj, index) => {
  // Set selected mode before validation
  if (obj && obj.option !== undefined && obj.option !== null) {
    setCurSelMode(obj.option);
  } else if (index != null && index >= 7) {
    setCurSelMode(index);
  }

  // Validate transaction ID based on payment method
  if (obj && obj.option && [1, 2, 3, 4].includes(obj.option)) {
    const req = isDefaultTransIdRequired(obj.option, dpaymethodsRequireTransId);
    const v = validateBusinessTransId(transId, req);
    if (!v.ok) {
      setTransIdFieldError(v.message);
      setShowError(true);
      setInlineError(v.message);
      return;
    }
  } else if (obj && obj.option === 6) {
    // For multiple mode, validate later in confirmPayment if needed
    const v = validateBusinessTransId(transId, false);
    if (!v.ok) {
      setTransIdFieldError(v.message);
      setShowError(true);
      setInlineError(v.message);
      return;
    }
  } else {
    const v = validateBusinessTransId(transId, false);
    if (!v.ok) {
      setTransIdFieldError(v.message);
      setShowError(true);
      setInlineError(v.message);
      return;
    }
  }
  
  setTransIdFieldError("");
  setShowError(false);
  setInlineError("");
  
  // Rest of your existing payAmount logic...
  setUserpayselect(null);
  setCustomModeOption(null);
  
  if (obj && obj.option) {
    setCurSelMode(obj.option);
    setShowMultiple(false);
    setShowCoupon(false);
    
    // Simple payment methods (Cash, Card, UPI, Wallet)
    if ([1, 2, 3, 4].includes(obj.option)) {
      const finalTransId = transId.trim() || `${Date.now()}`;
      onPaymentComplete({
        mode: obj.option,
        transId: finalTransId,
        paymentInfo: {},
        amount: totalAmount,
        paidAmount: totalAmount,
        balance: 0
      });
      return;
    }
    
    // Coupon mode
    if (obj.option === 5) {
      setShowCoupon(true);
      return;
    }
    
    // Multiple mode
    if (obj.option === 6) {
      setShowMultiple(true);
      updateBalance(0);
      return;
    }
  }
  
  // Custom payment methods (index >= 7)
  if (obj && index >= 7) {
    setShowMultiple(false);
    setShowCoupon(false);
    setCurSelMode(index);
    setCustomModeOption(obj);
    const defaultAmt = String(totalAmount);
    updatepayInfo({ userpaymethod: obj.title, usr_input: defaultAmt });
    
    // Check if custom method requires transaction ID
    const customMethod = userpaymethods.find((_, i) => i + 7 === index);
    const requiresTransId = customMethod?.requireTransactionId || false;
    
    const v = validateBusinessTransId(transId, requiresTransId);
    if (!v.ok) {
      setTransIdFieldError(v.message);
      setShowError(true);
      setInlineError(v.message);
      return;
    }
    
    // Rest of custom payment logic...
    const CustomPaymentInput = () => {
      const [inputValue, setInputValue] = useState(defaultAmt);
      
      const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        updatepayInfo({ usr_input: value });
      };
      
      return (
        <>
          <span>{obj.title}</span>
          <span>
            <span>
              Amount <img className="w-11" src={tranImg} alt="Amount" />
            </span>{" "}
            <input
              className="splitinput w-50"
              type="text"
              alt="pay"
              value={inputValue}
              onChange={handleInputChange}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </span>
        </>
      );
    };
    
    setUserpayselect(<CustomPaymentInput key="custom-payment" />);
    setBalance(0);
  } else {
    setUserpayselect(null);
    updatepayInfo({ userpaymethod: "" });
  }
};


const confirmPayment = () => {


  let required = false;
  
  if (curSelMode >= 1 && curSelMode <= 5) {
    required = isDefaultTransIdRequired(curSelMode, dpaymethodsRequireTransId);
  } else if (curSelMode === 6) {
    required = multipleSplitRequiresTransId(payInfo, dpaymethodsRequireTransId);
  } else if (curSelMode >= 7 && customModeOption) {
    const customMethod = userpaymethods.find((_, i) => i + 7 === curSelMode);
    required = customMethod?.requireTransactionId || false;
  }
  
  const v = validateBusinessTransId(transId, required);
  if (!v.ok) {
    setTransIdFieldError(v.message);
    setShowError(true);
    setInlineError(v.message);
    return;
  }
  
  setTransIdFieldError("");
  setShowError(false);
  setInlineError("");
  
  const finalTransId = transId.trim() || `${Date.now()}${Math.random().toString(36).substr(2, 6)}`;    
  
  // Multiple mode - Allow partial payments
  if (showMultiple && curSelMode === 6) {
    const cashAmt = parseFloat(payInfo.cash_amt) || 0;
    const ccAmt = parseFloat(payInfo.cc_amt) || 0;
    const upiAmt = parseFloat(payInfo.upi_amt) || 0;
    const walletAmt = parseFloat(payInfo.wallet_amt) || 0;
    
    const totalPaid = cashAmt + ccAmt + upiAmt + walletAmt;
    const remainingBalance = totalAmount - totalPaid;
    
    // Only validate that totalPaid doesn't exceed totalAmount
    if (totalPaid > totalAmount) {
      setInlineError(`Total paid (₹${totalPaid}) exceeds amount due (₹${totalAmount})`);
      return;
    }
    
    // Check if at least one payment method has amount > 0
    // if (totalPaid === 0) {
    //   setInlineError("Please enter at least one payment amount");
    //   return;
    // }
    
    // Send payment data with proper paidAmount and remaining balance
    onPaymentComplete({
      mode: 6,
      transId: finalTransId,
      paymentInfo: {
        cash_amt: payInfo.cash_amt || "0",
        cc_amt: payInfo.cc_amt || "0",
        upi_amt: payInfo.upi_amt || "0",
        upi_input: payInfo.upi_input || "",
        wallet_amt: payInfo.wallet_amt || "0",
        wallet_input: payInfo.wallet_input || "",
        userpaymethod: payInfo.userpaymethod || "",
      },
      amount: totalAmount,
      paidAmount: totalPaid,  // Amount paid in this transaction
      balance: remainingBalance // Remaining balance to be paid later
    });
    return;
  }
  
  // Coupon mode validation - Must equal total amount
  if (showCoupon && curSelMode === 5) {
    const couponAmt = parseFloat(payInfo.coupon_amt) || 0;
    
    if (Math.abs(couponAmt - totalAmount) > 0.01) {
      setInlineError(`Coupon amount must equal ₹${totalAmount}. Current: ₹${couponAmt}`);
      return;
    }
    
    onPaymentComplete({
      mode: 5,
      transId: finalTransId,
      paymentInfo: {
        coupon_input: payInfo.coupon_input || "",
        coupon_amt: payInfo.coupon_amt || "0",
      },
      amount: totalAmount,
      paidAmount: couponAmt,
      balance: 0
    });
    return;
  }
  
  // Custom payment mode - Must equal total amount
  if (customModeOption && curSelMode >= 7) {
    const customAmt = parseFloat(payInfo.usr_input) || 0;
    
    if (Math.abs(customAmt - totalAmount) > 0.01) {
      setInlineError(`Amount must equal ₹${totalAmount}. Current: ₹${customAmt}`);
      return;
    }
    
    onPaymentComplete({
      mode: curSelMode,
      transId: finalTransId,
      paymentInfo: {
        userpaymethod: payInfo.userpaymethod || customModeOption.title,
        usr_input: String(payInfo.usr_input),
      },
      amount: totalAmount,
      paidAmount: customAmt,
      balance: 0
    });
    return;
  }
};
  // Handle cancel
  const handleCancel = () => {
    setInlineError("");
    setTransId("");
    setPayInfo({
      cash_amt: "",
      cc_amt: "",
      upi_amt: "",
      upi_input: "",
      wallet_amt: "",
      wallet_input: "",
      userpaymethod: "",
      coupon_input: "",
      coupon_amt: "",
      usr_input: "",
    });
    onClose();
  };

  if (apiError) {
    return (
      <MDBModal open={open} setOpen={(v) => !v && onClose()} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalBody>
              <p className="mb-3">Could not load payment settings. Please try again.</p>
              <MDBBtn onClick={onClose}>Close</MDBBtn>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    );
  }

  const showFooter = showMultiple || showCoupon || userpayselect || customModeOption;

  return (
    <MDBModal open={open} setOpen={(v) => !v && onClose()} onClose={handleCancel} tabIndex="-1" centered>
      <MDBModalDialog size="lg" scrollable>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Complete Payment</MDBModalTitle>
            <MDBBtn className="btn-close" color="none" onClick={handleCancel} disabled={saving} />
          </MDBModalHeader>
          <MDBModalBody>
            <div className="d-flex space-between mb-2 mt-1 mob-block flex-wrap gap-2">
              <p className="mb-0 text-muted">All transactions are secure and encrypted.</p>
              <p className="mb-0">
                <b>
                  Total To Pay: <img className="w-11" src={tranImg} alt="" /> ₹{totalAmount}
                </b>
              </p>
            </div>

            {/* Payment Methods */}
            <div className="d-flex flex-wrap">
              {dpaymethods?.filter((item) => item === 1).length > 0 && (
                <div
                  className="paymt-clr-1"
                  style={{ cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.6 : 1 }}
                  onClick={() => !saving && payAmount({ option: 1 })}
                >
                  <img className="w-25" src={cash} alt="Cash" />
                  Cash
                </div>
              )}
              {dpaymethods?.filter((item) => item === 2).length > 0 && (
                <div
                  className="paymt-clr-2"
                  style={{ cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.6 : 1 }}
                  onClick={() => !saving && payAmount({ option: 2 })}
                >
                  <img className="w-25" src={ccImg} alt="Card" />
                  Card
                </div>
              )}
              {dpaymethods?.filter((item) => item === 3).length > 0 && (
                <div
                  className="paymt-clr-3"
                  style={{ cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.6 : 1 }}
                  onClick={() => !saving && payAmount({ option: 3 })}
                >
                  <img className="w-25" src={uiImg} alt="UPI" />
                  UPI
                </div>
              )}
              {dpaymethods?.filter((item) => item === 4).length > 0 && (
                <div
                  className="paymt-clr-4"
                  style={{ cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.6 : 1 }}
                  onClick={() => !saving && payAmount({ option: 4 })}
                >
                  <img className="w-25" src={wallet} alt="Wallet" />
                  Wallet
                </div>
              )}
              {dpaymethods?.filter((item) => item === 5).length > 0 && (
                <div
                  className="paymt-clr-5"
                  style={{ cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.6 : 1 }}
                  onClick={() => !saving && payAmount({ option: 5 })}
                >
                  <img className="w-25" src={coupon} alt="Coupon" />
                  Coupon
                </div>
              )}
              {userpaymethods?.map(
                (item, index) =>
                  item.check && (
                    <div
                      key={item._id || index}
                      className={"paymt-clr-" + (index + 7)}
                      style={{ cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.6 : 1 }}
                      onClick={() => !saving && payAmount(item, index + 7)}
                    >
                      <img className="w-25" src={otherpayments} alt={item.title} />
                      {item.title}
                    </div>
                  )
              )}
              <div
                className="paymt-clr-Multiple"
                style={{ cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.6 : 1 }}
                onClick={() => !saving && payAmount({ option: 6 })}
              >
                <img className="w-25" src={multiple} alt="Multiple" />
                Multiple
              </div>
            </div>

            {/* Transaction ID Input */}
        {/* Transaction ID Input - Update this section */}
<div className="mt-4 mb-3 d-flex flex-wrap align-items-center">
  <label className="me-2 mb-0">
    Transaction Id
    {curSelMode >= 1 && curSelMode <= 5 && isDefaultTransIdRequired(curSelMode, dpaymethodsRequireTransId) ? (
      <span className="text-danger"> *</span>
    ) : curSelMode === 6 && multipleSplitRequiresTransId(payInfo, dpaymethodsRequireTransId) ? (
      <span className="text-danger"> *</span>
    ) : curSelMode >= 7 && userpaymethods[curSelMode - 7]?.requireTransactionId ? (
      <span className="text-danger"> *</span>
    ) : (
      <span className="text-muted small"> (optional)</span>
    )}
  </label>
  <input
    type="text"
    className="form-control"
    style={{ maxWidth: 280 }}
    value={transId}
    disabled={saving}
    onChange={onTransIdChange}
    onBlur={(e) => {
      const v = validateBusinessTransId(e.target.value, false);
      if (!v.ok) {
        setTransIdFieldError(v.message);
        setShowError(true);
        setInlineError(v.message);
      } else {
        setShowError(false);
        setTransIdFieldError("");
      }
    }}
  />
</div>

{/* Show validation errors */}
{(transIdFieldError || showError) && (
  <div className="text-danger small mb-2">
    {transIdFieldError || "Please enter at least 4 characters for Transaction ID, or leave it empty."}
  </div>
)}
           

            {/* Custom Payment Input */}
            {userpayselect && <div className="splitenter mt-3">{userpayselect}</div>}

            {/* Coupon Section */}
            {showCoupon && (
              <div className="splitenter mt-3">
                <span>
                  Enter Coupon Code{" "}
                  <input
                    className="coupen-code"
                    type="text"
                    disabled={saving}
                    value={payInfo.coupon_input}
                    onChange={(e) => updatepayInfo({ coupon_input: e.target.value })}
                    placeholder="Enter Code Here"
                  />
                </span>
                <span className="ms-2">
                  <span>
                    Coupon Amount <img className="w-11" src={tranImg} alt="" />
                  </span>{" "}
                  <input
                    className="splitinput w-50"
                    type="text"
                    disabled={saving}
                    value={payInfo.coupon_amt}
                    onChange={(e) => updatepayInfo({ coupon_amt: e.target.value })}
                    onKeyPress={(event) => {
                      if (!/[0-9.]/.test(event.key)) event.preventDefault();
                    }}
                  />
                </span>
              </div>
            )}

            {/* Multiple Payment Section */}
            {showMultiple && (
              <div className="mt-3">
                <div className="pt-1 pb-1">
                  Pay balance amount using
                  <div className="duepaymentradio">
                    <div onClick={() => {}} style={{ zIndex: 2 }}>
                      <span>Enter cash to be paid</span>
                    </div>
                    <span>
                      <span>
                        <img className="w-11" src={tranImg} alt="" />
                      </span>
                      <input
                        className="splitinput w-50"
                        type="text"
                        disabled={saving}
                        value={payInfo.cash_amt}
                        onChange={(e) => updatepayInfo({ cash_amt: e.target.value })}
                        onKeyPress={(event) => {
                          if (!/[0-9.]/.test(event.key)) event.preventDefault();
                        }}
                      />
                    </span>
                  </div>
                </div>
                <div className="duepaymentradio">
                  <div onClick={() => {}} style={{ zIndex: 2 }}>
                    <span>Credit / Debit Card</span>
                  </div>
                  <span>
                    <span>
                      <img className="w-11" src={tranImg} alt="" />
                    </span>
                    <input
                      className="splitinput w-50"
                      type="text"
                      disabled={saving}
                      value={payInfo.cc_amt}
                      onChange={(e) => updatepayInfo({ cc_amt: e.target.value })}
                      onKeyPress={(event) => {
                        if (!/[0-9.]/.test(event.key)) event.preventDefault();
                      }}
                    />
                  </span>
                </div>
                <div className="duepaymentradio">
                  <div onClick={() => {}} style={{ zIndex: 2 }}>
                    <span>UPI</span>
                  </div>
                  <div>
                    <span>
                      <input
                        className="splitinputupi"
                        type="text"
                        placeholder="number@bank.com"
                        disabled={saving}
                        value={payInfo.upi_input}
                        onChange={(e) => updatepayInfo({ upi_input: e.target.value })}
                      />
                    </span>
                    <span>
                      <span>
                        <img className="w-11" src={tranImg} alt="" />
                      </span>{" "}
                      <input
                        className="splitinput w-50"
                        type="text"
                        disabled={saving}
                        value={payInfo.upi_amt}
                        onChange={(e) => updatepayInfo({ upi_amt: e.target.value })}
                        onKeyPress={(event) => {
                          if (!/[0-9.]/.test(event.key)) event.preventDefault();
                        }}
                      />
                    </span>
                  </div>
                </div>
                <div className="duepaymentradio">
                  <div onClick={() => {}} style={{ zIndex: 2 }}>
                    <span>Wallets</span>
                  </div>
                  <div>
                    <span>
                      <input
                        className="splitinputwallet splitinputupi"
                        type="text"
                        placeholder="123456789"
                        disabled={saving}
                        value={payInfo.wallet_input}
                        onChange={(e) => updatepayInfo({ wallet_input: e.target.value })}
                      />
                    </span>
                    <span>
                      <span>
                        <img className="w-11" src={tranImg} alt="" />
                      </span>{" "}
                      <input
                        className="splitinput w-50"
                        type="text"
                        disabled={saving}
                        value={payInfo.wallet_amt}
                        onChange={(e) => updatepayInfo({ wallet_amt: e.target.value })}
                        onKeyPress={(event) => {
                          if (!/[0-9.]/.test(event.key)) event.preventDefault();
                        }}
                      />
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Error Messages */}
            {/* {inlineError && <div className="text-danger small my-2">{inlineError}</div>} */}
            {/* {serverError && (
              <div className="text-danger small my-2">{serverError}</div>
            )} */}

            {/* Footer with Balance and Buttons */}
            {showFooter && (
              <>
                <div className="d-flex space-between mb-2 mt-3 clr-red">
                  <span>Balance due amount</span>
                  <span>
                    <img className="w-11" src={tranImg} alt="" />
                    ₹{balance}
                  </span>
                </div>
                <div className="d-flex justify-content-end gap-2 pt-2 pb-1">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={saving}
                    onClick={confirmPayment}
                  >
                    {saving ? (
                      <>
                        <MDBSpinner size='sm' className="me-2" />
                        Processing...
                      </>
                    ) : (
                      "Done"
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    disabled={saving}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

export default PlanChangePayment;